import React, { useCallback } from 'react';
import { useCheckUniqueApiSource } from '@shared/hooks/useCheckUniqueApiSource';
import { GoBack } from '@shared/assets/svgs/GoBack';
import { LANDING_PAGE_VIEWS } from '@shared/config/constants/app';
import { useAtomValue } from 'jotai';
import { globalAtom } from '@shared/store/slice-atoms';
import { useHistory } from 'react-router-dom';
import { changeLandingPageView } from '@shared/store/slices/global.actions';
import Logo from '@shared/ui/logo/ui/Logo';
import { useWideLayout } from '@shared/hooks';
import { LanguageSelector } from '@shared/ui/language-selector';

const SubHeaderTVMenu = ({
  languageConfig = {},
  isMin = false,
  logoConfig = {},
  renderLogo = true,
  isPinForm = false,
}) => {
  const { isTVLayout } = useWideLayout();
  const uniqueApiSource = useCheckUniqueApiSource();
  const history = useHistory();

  const { landingPageView } = useAtomValue(globalAtom);

  const isV3PhoneNumberView = landingPageView === LANDING_PAGE_VIEWS.PHONE_NUMBER;

  const onGoBack = useCallback(() => {
    if (isPinForm) {
      history.goBack();
      return;
    }
    changeLandingPageView(LANDING_PAGE_VIEWS.MAIN);
  }, [history, isPinForm]);

  if (!isTVLayout) return null;

  return (
    <div className="layout-tv-menu">
      {/* INLINE STYLES */}
      <div onClick={onGoBack} tabIndex={1} style={{ cursor: 'pointer' }}>
        {isV3PhoneNumberView ? <GoBack /> : null}
      </div>
      <div className="layout-tv-menu-logo-wrapper">
        {isV3PhoneNumberView ? (
          <Logo
            renderLogo={renderLogo}
            // @ts-ignore
            logoConfig={logoConfig}
            isMin={isMin}
            uniqueApiSource={uniqueApiSource}
          />
        ) : null}
      </div>
      <div>
        <LanguageSelector languageConfig={languageConfig} />
      </div>
    </div>
  );
};

export { SubHeaderTVMenu };
